/** Nationalités du parcours « j'arrive en France » : adjectif FR (forme féminine)
 *  pour l'affichage du SELECT, associé au code pays ISO 3166-1 alpha-2 envoyé au
 *  back-end (metadata.nationality). Liste métier fournie ; ordre conservé tel quel. */
export type Nationality = { code: string; label: string }

export const NATIONALITIES: readonly Nationality[] = [
  { code: 'AF', label: 'Afghane' },
  { code: 'AL', label: 'Albanaise' },
  { code: 'DZ', label: 'Algérienne' },
  { code: 'DE', label: 'Allemande' },
  { code: 'US', label: 'Américaine' },
  { code: 'AD', label: 'Andorrane' },
  { code: 'AO', label: 'Angolaise' },
  { code: 'AG', label: 'Antiguaise et barbudienne' },
  { code: 'AR', label: 'Argentine' },
  { code: 'AM', label: 'Arménienne' },
  { code: 'AU', label: 'Australienne' },
  { code: 'AT', label: 'Autrichienne' },
  { code: 'AZ', label: 'Azerbaïdjanaise' },
  { code: 'BS', label: 'Bahamienne' },
  { code: 'BH', label: 'Bahreinienne' },
  { code: 'BD', label: 'Bangladaise' },
  { code: 'BB', label: 'Barbadienne' },
  { code: 'BE', label: 'Belge' },
  { code: 'BT', label: 'Bhoutanaise' },
  { code: 'MM', label: 'Birmane' },
  { code: 'GW', label: 'Bissau-Guinéenne' },
  { code: 'BY', label: 'Biélorusse' },
  { code: 'BO', label: 'Bolivienne' },
  { code: 'BA', label: 'Bosnienne' },
  { code: 'BW', label: 'Botswanaise' },
  { code: 'GB', label: 'Britannique (RU)' },
  { code: 'BN', label: 'Bruneienne' },
  { code: 'BR', label: 'Brésilienne' },
  { code: 'BG', label: 'Bulgare' },
  { code: 'BF', label: 'Burkinabé' },
  { code: 'BI', label: 'Burundaise' },
  { code: 'BZ', label: 'Bélizienne' },
  { code: 'BJ', label: 'Béninoise' },
  { code: 'KH', label: 'Cambodgienne' },
  { code: 'CM', label: 'Camerounaise' },
  { code: 'CA', label: 'Canadienne' },
  { code: 'CV', label: 'Cap-verdienne' },
  { code: 'CF', label: 'Centrafricaine' },
  { code: 'CL', label: 'Chilienne' },
  { code: 'CN', label: 'Chinoise' },
  { code: 'CY', label: 'Chypriote' },
  { code: 'CO', label: 'Colombienne' },
  { code: 'KM', label: 'Comorienne' },
  { code: 'CG', label: 'Congolaise' },
  { code: 'CD', label: 'Congolaise (Kinshasa)' },
  { code: 'CR', label: 'Costaricaine' },
  { code: 'HR', label: 'Croate' },
  { code: 'CU', label: 'Cubaine' },
  { code: 'DK', label: 'Danoise' },
  { code: 'DJ', label: 'Djiboutienne' },
  { code: 'DO', label: 'Dominicaine' },
  { code: 'DM', label: 'Dominiquaise' },
  { code: 'ES', label: 'Espagnole' },
  { code: 'TL', label: 'Est-timoraise' },
  { code: 'EE', label: 'Estonienne' },
  { code: 'FJ', label: 'Fidjienne' },
  { code: 'FI', label: 'Finlandaise' },
  { code: 'GA', label: 'Gabonaise' },
  { code: 'GM', label: 'Gambienne' },
  { code: 'GE', label: 'Georgienne' },
  { code: 'GH', label: 'Ghanéenne' },
  { code: 'GD', label: 'Grenadienne' },
  { code: 'GT', label: 'Guatemaltèque' },
  { code: 'GN', label: 'Guinéenne' },
  { code: 'GY', label: 'Guyanaise (Guyana)' },
  { code: 'GF', label: 'Guyanienne' },
  { code: 'HT', label: 'Haïtienne' },
  { code: 'GR', label: 'Hellénique' },
  { code: 'HN', label: 'Hondurienne' },
  { code: 'HU', label: 'Hongroise' },
  { code: 'IN', label: 'Indienne' },
  { code: 'ID', label: 'Indonésienne' },
  { code: 'IQ', label: 'Irakienne' },
  { code: 'IR', label: 'Iranienne' },
  { code: 'IE', label: 'Irlandaise' },
  { code: 'IS', label: 'Islandaise' },
  { code: 'IL', label: 'Israélienne' },
  { code: 'IT', label: 'Italienne' },
  { code: 'CI', label: 'Ivoirienne' },
  { code: 'JM', label: 'Jamaïcaine' },
  { code: 'JP', label: 'Japonaise' },
  { code: 'JO', label: 'Jordanienne' },
  { code: 'KZ', label: 'Kazakhstanaise' },
  { code: 'KE', label: 'Kenyane' },
  { code: 'KG', label: 'Kirghize' },
  { code: 'KI', label: 'Kiribatienne' },
  { code: 'KN', label: 'Kittitienne-et-névicienne' },
  { code: 'KW', label: 'Koweitienne' },
  { code: 'LA', label: 'Laotienne' },
  { code: 'LS', label: 'Lesothane' },
  { code: 'LV', label: 'Lettone' },
  { code: 'LB', label: 'Libanaise' },
  { code: 'LY', label: 'Libyenne' },
  { code: 'LR', label: 'Libérienne' },
  { code: 'LI', label: 'Liechtensteinoise' },
  { code: 'LT', label: 'Lituanienne' },
  { code: 'LU', label: 'Luxembourgeoise' },
  { code: 'MK', label: 'Macédonienne' },
  { code: 'MY', label: 'Malaisienne' },
  { code: 'MW', label: 'Malawienne' },
  { code: 'MV', label: 'Maldivienne' },
  { code: 'MG', label: 'Malgache' },
  { code: 'ML', label: 'Malienne' },
  { code: 'MT', label: 'Maltaise' },
  { code: 'MA', label: 'Marocaine' },
  { code: 'MH', label: 'Marshallaise' },
  { code: 'MU', label: 'Mauricienne' },
  { code: 'MR', label: 'Mauritanienne' },
  { code: 'MX', label: 'Mexicaine' },
  { code: 'FM', label: 'Micronésienne' },
  { code: 'MD', label: 'Moldave' },
  { code: 'MN', label: 'Mongole' },
  { code: 'ME', label: 'Monténégrine' },
  { code: 'MC', label: 'Monégasque' },
  { code: 'MZ', label: 'Mozambicaine' },
  { code: 'NA', label: 'Namibienne' },
  { code: 'NR', label: 'Nauruane' },
  { code: 'NI', label: 'Nicaraguayenne' },
  { code: 'NG', label: 'Nigériane' },
  { code: 'NE', label: 'Nigérienne' },
  { code: 'KP', label: 'Nord-coréenne' },
  { code: 'NO', label: 'Norvégienne' },
  { code: 'NL', label: 'Néerlandaise' },
  { code: 'NZ', label: 'Néo-zélandaise' },
  { code: 'NP', label: 'Népalaise' },
  { code: 'OM', label: 'Omanaise' },
  { code: 'UG', label: 'Ougandaise' },
  { code: 'UZ', label: 'Ouzbeke' },
  { code: 'PK', label: 'Pakistanaise' },
  { code: 'PW', label: 'Palau' },
  { code: 'PS', label: 'Palestinienne' },
  { code: 'PA', label: 'Panaméenne' },
  { code: 'PG', label: 'Papouane-néoguinéenne' },
  { code: 'PY', label: 'Paraguayenne' },
  { code: 'PH', label: 'Philippine' },
  { code: 'PL', label: 'Polonaise' },
  { code: 'PR', label: 'Portoricaine' },
  { code: 'PT', label: 'Portugaise' },
  { code: 'PE', label: 'Péruvienne' },
  { code: 'QA', label: 'Qatarienne' },
  { code: 'RO', label: 'Roumaine' },
  { code: 'RU', label: 'Russe' },
  { code: 'RW', label: 'Rwandaise' },
  { code: 'LC', label: 'Saint-Lucienne' },
  { code: 'SM', label: 'Saint-Marinaise' },
  { code: 'VC', label: 'Saint-Vincentaise-et-Grenadine' },
  { code: 'SB', label: 'Salomonaise' },
  { code: 'SV', label: 'Salvadorienne' },
  { code: 'WS', label: 'Samoane' },
  { code: 'ST', label: 'Santoméenne' },
  { code: 'SA', label: 'Saoudienne' },
  { code: 'RS', label: 'Serbe' },
  { code: 'SC', label: 'Seychelloise' },
  { code: 'SL', label: 'Sierra-leonaise' },
  { code: 'SG', label: 'Singapourienne' },
  { code: 'SK', label: 'Slovaque' },
  { code: 'SI', label: 'Slovène' },
  { code: 'SO', label: 'Somalienne' },
  { code: 'SD', label: 'Soudanaise' },
  { code: 'LK', label: 'Sri-lankaise' },
  { code: 'ZA', label: 'Sud-africaine' },
  { code: 'KR', label: 'Sud-coréenne' },
  { code: 'SS', label: 'Sud-soudanaise' },
  { code: 'CH', label: 'Suisse' },
  { code: 'SR', label: 'Surinamaise' },
  { code: 'SE', label: 'Suédoise' },
  { code: 'SY', label: 'Syrienne' },
  { code: 'SN', label: 'Sénégalaise' },
  { code: 'TJ', label: 'Tadjike' },
  { code: 'TW', label: 'Taiwanaise' },
  { code: 'TZ', label: 'Tanzanienne' },
  { code: 'TD', label: 'Tchadienne' },
  { code: 'CZ', label: 'Tchèque' },
  { code: 'TH', label: 'Thaïlandaise' },
  { code: 'TG', label: 'Togolaise' },
  { code: 'TO', label: 'Tongienne' },
  { code: 'TT', label: 'Trinidadienne' },
  { code: 'TN', label: 'Tunisienne' },
  { code: 'TM', label: 'Turkmène' },
  { code: 'TR', label: 'Turque' },
  { code: 'TV', label: 'Tuvaluane' },
  { code: 'UA', label: 'Ukrainienne' },
  { code: 'UY', label: 'Uruguayenne' },
  { code: 'VU', label: 'Vanuatuane' },
  { code: 'VN', label: 'Vietnamienne' },
  { code: 'VE', label: 'Vénézuélienne' },
  { code: 'YE', label: 'Yéménite' },
  { code: 'ZM', label: 'Zambienne' },
  { code: 'ZW', label: 'Zimbabwéenne' },
  { code: 'EG', label: 'Égyptienne' },
  { code: 'AE', label: 'Émirienne' },
  { code: 'GQ', label: 'Équato-guinéenne' },
  { code: 'EC', label: 'Équatorienne' },
  { code: 'ER', label: 'Érythréenne' },
  { code: 'ET', label: 'Éthiopienne' },
] as const
